import {ReactNode} from 'react';
import {UserDataProps} from '@common/types/user';
import isEmpty from '../helpers/isEmpty';

type Props = {
  children: ReactNode;
  user?: UserDataProps;
};
/**
 * Wrapper for content that should be displayed for logged in user only
 * Simpler, props-based version from Verkkopalvelu
 * Also see @shared/components/EnsureUser which is based on redux & user-api
 */
const EnsureUser = ({user, children}: Props) => {
  if (isEmpty(user)) {
    return null;
  }
  return children;
};

export default EnsureUser;
